import React from 'react';
import { ArrowRight, Home, Search, Key, TrendingUp } from 'lucide-react';

const ServiceCard = ({ icon: Icon, title, description, features }) => (
  <div className="group bg-[#f6f5e8] p-8 lg:p-10 hover:bg-[#1a365d] transition-all duration-300">
    <div className="flex items-start gap-6">
      <div className="w-12 h-12 flex items-center justify-center bg-[#fffef2] group-hover:bg-white/20 transition-colors">
        <Icon className="w-6 h-6 text-[#1a365d] group-hover:text-white transition-colors" />
      </div>
      <div className="flex-1">
        <h3 className="text-xl font-medium text-[#333333] group-hover:text-white transition-colors mb-3">
          {title}
        </h3>
        <p className="text-sm text-[#666666] group-hover:text-white/80 transition-colors leading-relaxed mb-6">
          {description}
        </p>
        <ul className="space-y-2">
          <li className="flex items-center gap-2 text-sm text-[#666666] group-hover:text-white/70 transition-colors">
            <span className="w-1.5 h-1.5 bg-[#1a365d] group-hover:bg-white/50 rounded-full"></span>
            {features[0]}
          </li>
          <li className="flex items-center gap-2 text-sm text-[#666666] group-hover:text-white/70 transition-colors">
            <span className="w-1.5 h-1.5 bg-[#1a365d] group-hover:bg-white/50 rounded-full"></span>
            {features[1]}
          </li>
          <li className="flex items-center gap-2 text-sm text-[#666666] group-hover:text-white/70 transition-colors">
            <span className="w-1.5 h-1.5 bg-[#1a365d] group-hover:bg-white/50 rounded-full"></span>
            {features[2]}
          </li>
          <li className="flex items-center gap-2 text-sm text-[#666666] group-hover:text-white/70 transition-colors">
            <span className="w-1.5 h-1.5 bg-[#1a365d] group-hover:bg-white/50 rounded-full"></span>
            {features[3]}
          </li>
        </ul>
      </div>
    </div>
  </div>
);

const Services = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    document.querySelector('#contacto')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="servicios" className="bg-[#fffef2] py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-16">
          <div className="max-w-2xl">
            <span className="text-sm text-[#1a365d] tracking-wider uppercase">Servicios</span>
            <h2 className="text-3xl lg:text-4xl font-light text-[#333333] mt-4 leading-tight">
              Soluciones inmobiliarias integrales
            </h2>
            <p className="text-base text-[#666666] mt-4 leading-relaxed">
              Ofrezco un servicio completo y personalizado para cada etapa de tu operación inmobiliaria.
            </p>
          </div>
          <button
            onClick={scrollToContact}
            className="hidden lg:flex items-center gap-2 text-sm text-[#1a365d] hover:text-[#333333] transition-colors mt-6 lg:mt-0 group"
          >
            Consulta gratuita
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <ServiceCard
            icon={Home}
            title="Venta de Propiedades"
            description="Gestión integral del proceso de venta: valoración profesional, estrategia de marketing personalizada, negociación y cierre de operación."
            features={["Valoración gratuita", "Marketing premium", "Negociación experta", "Asesoramiento legal"]}
          />
          <ServiceCard
            icon={Search}
            title="Compra de Inmuebles"
            description="Acompañamiento completo en la búsqueda y adquisición de tu propiedad ideal, adaptada a tus necesidades y presupuesto."
            features={["Búsqueda personalizada", "Análisis de mercado", "Visitas coordinadas", "Due diligence"]}
          />
          <ServiceCard
            icon={Key}
            title="Gestión de Alquileres"
            description="Servicio completo de gestión de alquiler, desde la búsqueda de inquilinos hasta la administración continua de la propiedad."
            features={["Selección de inquilinos", "Contratos seguros", "Gestión de incidencias", "Cobro de rentas"]}
          />
          <ServiceCard
            icon={TrendingUp}
            title="Asesoramiento Patrimonial"
            description="Consultoría especializada para optimizar tu patrimonio inmobiliario y tomar las mejores decisiones de inversión."
            features={["Análisis patrimonial", "Estrategia de inversión", "Fiscalidad inmobiliaria", "Planificación a largo plazo"]}
          />
        </div>

        <button
          onClick={scrollToContact}
          className="lg:hidden flex items-center justify-center gap-2 w-full mt-8 px-8 py-4 bg-[#1a365d] text-white text-sm font-medium"
        >
          Solicitar Información
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </section>
  );
};

export default Services;
